// Global Types
import type {
  $Translate,
} from 'common.language';
import type {
  $FullRegionSeason,
  $Model,
} from 'common.data';

// Global Components
import * as React from 'react';
import {
  Button,
  Card,
  Table,
} from 'reactstrap';
import {
  Loader,
  SectionHeader,
} from '@vroskus/library-components';

// Helpers
import {
  defaultGetData,
} from '../../../../helpers';

// Components
import EmptyTable from '../../../common/EmptyTable';

// Services
import Services from '../../../../services';

// Types
type $RegattaWithFullRegionSeason = $Model<'Regatta'> & {
  RegionSeason: $FullRegionSeason;
};

type $Props = $Translate & {
  id: string;
};

type $State = {
  data: Array<$RegattaWithFullRegionSeason>;
  loading: boolean;
};

class ProfileInvoicesSectionView extends React.Component<$Props, $State> {
  constructor(props: $Props) {
    super(props);

    this.state = {
      data: [],
      loading: false,
    };
  }

  componentDidMount(): void {
    this.getData();
    this.setupSocket();
  }

  setupSocket(): void {
    Services.Socket.on({
      action: (data) => {
        if (data.modelName === 'Regatta') {
          this.getData();
        }
      },
      type: Services.Socket.type.modelChangedEvent,
    });
  }

  setStateAsync(state: Partial<$State>): Promise<void> {
    return new Promise((resolve) => {
      this.setState(
        (pervState: $State) => ({
          ...pervState,
          ...state,
        }),
        resolve,
      );
    });
  }

  async getData(): Promise<void> {
    await defaultGetData({
      action: async () => {
        await this.setStateAsync({
          loading: true,
        });

        const data = await Services.Api.getManyAuthUserRegattaInvoice();

        await this.setStateAsync({
          data,
          loading: false,
        });
      },
      errorAction: async () => this.setStateAsync({
        loading: false,
      }),
    });
  }

  renderHeader() {
    const {
      t,
    } = this.props;

    return (
      <SectionHeader
        bottomBorder
        title={t('Invoices')}
      />
    );
  }

  renderTable() {
    const {
      t,
    } = this.props;
    const {
      data,
    } = this.state;

    return data.length === 0 ? (
      <EmptyTable />
    ) : (
      <Table responsive>
        <thead>
          <tr>
            <th>{t('Regatta')}</th>
            <th>{t('Region')}</th>
            <th>{t('Season')}</th>
            <th />
          </tr>
        </thead>
        <tbody>
          {data.map((dataItem: $RegattaWithFullRegionSeason) => (
            <tr key={dataItem.id}>
              <td>{dataItem.Name}</td>
              <td>{dataItem.RegionSeason.Region.Name}</td>
              <td>{dataItem.RegionSeason.Name}</td>
              <td>
                <div className={'d-flex justify-content-end'}>
                  <Button
                    color={'secondary'}
                    href={dataItem.Invoice}
                    id={`regatta-invoice-button-${dataItem.id}`}
                    outline
                    size={'sm'}
                    target={'_blank'}
                  >
                    <em className={'far fa-file-pdf mr-1'} />
                    {t('Invoice')}
                  </Button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    );
  }

  renderContent() {
    const {
      loading,
    } = this.state;

    return (
      <Loader
        loading={loading === true}
        overlay
      >
        {this.renderTable()}
      </Loader>
    );
  }

  render() {
    const {
      id,
    } = this.props;

    return (
      <Card id={id}>
        {this.renderHeader()}
        {this.renderContent()}
      </Card>
    );
  }
}

export default ProfileInvoicesSectionView;
